import { useState } from 'react';
import styled from 'styled-components';

import { media } from '~/utils';

import StartVideoIcon from '@public/images/start-video.svg';

type Props = {
  image: string;
  video: string;
};

export function VideoWithThumbnail({ image, video }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <Wrapper>
      {open && (
        <OverlayWrapper onClick={() => setOpen(false)}>
          <VideoWrapper>
            <Video
              width='560'
              height='315'
              src={video}
              allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
            />
            <Close onClick={() => setOpen(false)} src='/images/close.svg' />
          </VideoWrapper>
        </OverlayWrapper>
      )}
      <ImageWrapper onClick={() => setOpen(true)}>
        <Image src={image} alt='image-video' />
        <Icon>
          <StartVideoIcon />
        </Icon>
      </ImageWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`;

const Icon = styled.div`
  position: absolute;
  top: calc(50% - 34px);
  left: calc(50% - 42px);
  width: 84px;
  height: 68px;
  cursor: pointer;
`;

const OverlayWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${'rgba(38, 38, 38, 0.7)'};
  backdrop-filter: blur(10px);
`;

const VideoWrapper = styled.div`
  width: 830px;
  height: 600px;
  position: relative;

  ${media.mid`
    height: auto;
    width: 100%;
    padding-top: 56.25%;
    object-fit: cover;
  `}
`;

const Video = styled.iframe`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;

const Close = styled.img`
  position: absolute;
  top: -15px;
  right: -15px;
  cursor: pointer;

  ${media.mid`
    top: -50px;
    right: 10px;
  `}
`;
